export default __webpack_public_path__ + "static/media/austin-pacht-2.bf36356b.png";